import {Component, Host, h, Prop} from '@stencil/core';
import {CompanyViewModel} from "@modules/onBoarding/presentation/viewModel/CompanyViewModel";
import {RegistrationViewModel} from "@modules/onBoarding/presentation/viewModel/RegistrationViewModel";

@Component({
    tag: 'registration-view',
    styleUrl: 'registration-view.css',
    scoped: true,
})
export class RegistrationView {

    @Prop() company: CompanyViewModel

    @Prop() viewModel: RegistrationViewModel;

    private renderPhoneRegionSelect() {
        return (
            <select id="phoneRegion" name="phoneRegion"
                    class="custom-select form-control" data-testid="onboarding.registration-form.phoneCodes">
                {this.viewModel.phoneCodes.map(phoneCode => (
                    <option value={phoneCode.value} selected={phoneCode.selected} innerHTML={phoneCode.text}></option>
                ))}
            </select>
        );
    }

    render() {
        return (
            <Host>
                <div id="registration-view" class="d-flex justify-content-center bg-primary position-relative">
                    <div class="container position-absolute">
                        <div id="content-container" class="mx-auto">
                            <svg class="my-3" aria-hidden="true" width="100%" height="2rem">
                                <use
                                    data-href={this.viewModel.taglineHref}></use>
                            </svg>
                            <div class="card shadow container pt-4 pb-5">
                                <div class="ml-4">
                                    <a href={this.viewModel.modifySearchLink}>{this.viewModel.modifySearch}</a>
                                </div>
                                <form class="col-8 offset-2" data-testid="onboarding.registration.form">
                                    <nav class="my-4">
                                    </nav>
                                    <h1 class="title_sm mb-4">{this.viewModel.title}</h1>
                                    <div class="px-3 pt-3">
                                        <company-infos company={this.company}></company-infos>
                                    </div>
                                    <hr class="bg-lyreco-green mb-4"/>
                                    <h2 class="title_xs pt-2 mb-3">{this.viewModel.subtitle}</h2>
                                    <div class="form-group">
                                        <label class="text-primary font-weight-bold"
                                               htmlFor="businessEmail">{this.viewModel.businessEmailLabel} *</label>
                                        <div class="input-group mb-1">
                                            <input type="text" class="form-control" name="businessEmail"
                                                   id="businessEmail"
                                                   placeholder={this.viewModel.businessEmailPlaceholder}
                                                   data-testid="onboarding.registration-form.businessEmail"
                                            />
                                        </div>
                                        <span>{this.viewModel.businessEmailInfoText}</span>
                                    </div>
                                    <div class="d-flex">
                                        <div class="form-group">
                                            <label class="text-primary font-weight-bold"
                                                   htmlFor="firstName">{this.viewModel.firstNameLabel} *</label>

                                            <div class="input-group">
                                                <input type="text" class="form-control" name="firstName"
                                                       id="firstName"
                                                       placeholder={this.viewModel.firstNamePlaceholder}
                                                       data-testid="onboarding.registration-form.firstName"
                                                />
                                            </div>
                                        </div>
                                        <div class="pl-3 form-group">
                                            <label class="text-primary font-weight-bold"
                                                   htmlFor="lastName">{this.viewModel.lastNameLabel} *</label>

                                            <div class="input-group">
                                                <input type="text" class="form-control" name="lastName"
                                                       id="lastName"
                                                       placeholder={this.viewModel.lastNamePlaceholder}
                                                       data-testid="onboarding.registration-form.lastName"
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-group">
                                        <label class="text-primary font-weight-bold"
                                               htmlFor="phoneNumber">{this.viewModel.phoneNumberLabel} *</label>
                                        <div id="phone-input" class="phone-input input-group">
                                            <div class="input-group-prepend">
                                                {this.renderPhoneRegionSelect()}
                                            </div>
                                            <input id="phoneNumber"
                                                   name="phoneNumber"
                                                   type="text" class="form-control"
                                                   placeholder={this.viewModel.phoneNumberPlaceholder}
                                                   data-testid="onboarding.registration-form.phoneNumber"
                                            />
                                        </div>
                                    </div>

                                    <span class="small text_secondary">* {this.viewModel.mandatoryFields}</span>

                                    <hr class="bg-lyreco-green"/>

                                    <div class="form-group custom-control custom-checkbox mb-3">
                                        <input type="checkbox" class="custom-control-input"
                                               id="termsAndConditions"
                                               value="true"
                                        />
                                        <label class="custom-control-label" htmlFor="termsAndConditions">
                                            {this.viewModel.termsAndConditionsText}
                                            <a href={this.viewModel.termsAndConditionsLink} target="_blank">
                                                {this.viewModel.termsAndConditionsLinkLabel}
                                            </a> *
                                        </label>
                                    </div>

                                    <button
                                        class="btn btn-primary text-white w-100">{this.viewModel.completeMyRegistration}</button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </Host>
        );
    }
}
